import { STATUS_TYPES, Story } from '@shared/api/types/story';

import desktopBannerSrc from '../assets/zns-story-banner-desktop.jpg';
import mobileBannerSrc from '../assets/zns-story-banner-mobile.jpg';
import connectNameService1Src from '../assets/zns-story-connect-name-service-1.png';
import connectNameService2Src from '../assets/zns-story-connect-name-service-2.png';
import connectNameService3Src from '../assets/zns-story-connect-name-service-3.png';
import connectNameService4Src from '../assets/zns-story-connect-name-service-4.png';
import connectNameService5Src from '../assets/zns-story-connect-name-service-5.png';
import faucetChannel1Src from '../assets/zns-story-faucet-channel-1.png';
import faucetChannel2Src from '../assets/zns-story-faucet-channel-2.png';
import getZetaChainAddress1Src from '../assets/zns-story-get-zetachain-address-1.png';
import getZetaChainAddress2Src from '../assets/zns-story-get-zetachain-address-2.png';
import getZetaChainAddress3Src from '../assets/zns-story-get-zetachain-address-3.png';
import getZetaChainAddress4Src from '../assets/zns-story-get-zetachain-address-4.png';
import verifyDiscordSrc from '../assets/zns-story-verify-discord.png';
import verifyTwitterSrc from '../assets/zns-story-verify-twitter.png';

export const magicSquareZnsConnectCampaignGuide: Story = {
  id: 'magic-square-zns-connect-campaign-guide',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Square ZNS Connect Campaign Guide',
  index: 0,
  content: {
    type: 'HTML',
    metadata: {
      title: 'Your Ultimate Guide to Participating in the ZNS Connect Campaign on the Magic Store',
      description:
        'Discover the secret to earning MATIC rewards through the ZNS Connect Campaign on the Magic Store. Our comprehensive guide walks you through the process step by step, ensuring you make the most of this exciting opportunity. Join now!',
      keywords:
        'ZNS Connect Campaign, Magic Store MATIC rewards, MATIC token, Earn cryptocurrency, Participate in ZNS Connect, MATIC rewards guide, Crypto rewards, Magic Store platform, MATIC ecosystem, Crypto investment opportunities',
    },
    hardcodedHtml: /* html */ `
    <picture>
      <source media="(min-width:568px)" width="3484" height="592" srcset="${desktopBannerSrc.src}">
      <img src="${mobileBannerSrc.src}"  width="550" height="212" alt="Banner">
    </picture>

    <div class="html-layout-container">

      <h1 class="html-text-center">
        A Step-by-Step Guide for Minting Testnet Domains via ZNS Connect
      </h1>

      <p>
        At Magic Store, our unwavering commitment is to simplify and elevate the user experience within the blockchain universe. Understanding the challenges many encounter with conventional blockchain addresses, we've forged a partnership with ZNS Connect, a cutting-edge decentralized naming system on the Zetachain blockchain. To help our community capitalize on the advantages of this collaboration, we're rolling out a detailed step-by-step guide. Moreover, participants can also earn an incentive of 0.3 MATIC for their efforts.
      </p>

      <p class="html-text-center">
        <a href="/hot-offers/zns-connect" class="html-button-primary">
          Start your Minting journey!
        </a>
      </p>

      <section>
        <h2>
          1. Join ZetaChain Discord
        </h2>
        <p class="html-list-item">
          Click on <a href="https://discord.com/invite/zetachain" rel="noopener noreferrer" target="_blank">this link</a> to join ZetaChain Discord
        </p>
      </section>

      <section>
        <h2>
          2. Verify your Discord account
        </h2>

        <img src="${verifyDiscordSrc.src}" alt="Verifying with discord" width="2324" height="1308"/>
      </section>

      <section>
        <h2>
          3. Verify your Twitter on ZetaChain Discord
        </h2>

        <p class="html-list-item">
          Go to Discord Server (ZetaChain) Settings and click on the dropdown menu and click on Linked Roles. After that choose the Faucet Access and authorise the access to your Twitter (X) Account. <span class="html-font-bold">Inactive accounts (suspended) and accounts less than 30 days old won't be accepted.</span>
        </p>

        <img src="${verifyTwitterSrc.src}" alt="Verifying with twitter" width="2324" height="1308"/>
      </section>

      <section>
        <h2>
          4. Get your ZetaChain address.
        </h2>

        <img src="${getZetaChainAddress1Src.src}" alt="Showing where is the button on the screen" width="2324" height="1308"/>

        <p class="html-list-item">
          Go to ZNS Connect and click on the button pointed on the screen with a red arrow
        </p>

        <img src="${getZetaChainAddress2Src.src}" alt="Showing how to switch network" width="2324" height="1308"/>

        <p class="html-list-item">
          Choose the ZetaChain Athens 3. Approve it in your Wallet when you get the Pop-up.
        </p>

        <img src="${getZetaChainAddress3Src.src}" alt="Showing where to click" width="2324" height="551"/>

        <p class="html-list-item">
          Click Here
        </p>

        <img src="${getZetaChainAddress4Src.src}" alt="Showing where to click to copy address" width="2324" height="1308"/>

        <p class="html-list-item">
          Copy Your Address, and go back to the Discord.
        </p>
      </section>


      <section>
        <h2>
          5. Go to the faucet channel
        </h2>

        <img src="${faucetChannel1Src.src}" alt="Showing where faucet channel in discord" width="2324" height="757"/>

        <p class="html-list-item">
          Write your address and request Test tokens. Make sure to write: <span class="html-underline html-font-regular">Zeta Faucet Drip (Your Address) Zetachain.</span> Then you will receive a message that you have successfully requested. After 3-5 minutes they will send you 3.0 ZETA.
        </p>

        <img src="${faucetChannel2Src.src}" alt="Showing where and what to send in chat" width="2324" height="757"/>
      </section>

      <section>
        <h2>
          6. Go back to the ZNS Connect Name Service
        </h2>

        <p class="html-list-item">
          Search any domain name you would like to mint.
        </p>

        <img src="${connectNameService1Src.src}" alt="Showing where to search" width="2324" height="1308"/>

        <p class="html-list-item">
          Choose if you want .zeta or .zero and click “Register Now”
        </p>

        <img src="${connectNameService2Src.src}" alt="Zeta and zero options" width="2324" height="1308"/>

        <p class="html-list-item">
          Click on the “Continue with registration”
        </p>

        <img src="${connectNameService3Src.src}" alt="Showing where to click" width="2324" height="915"/>

        <p class="html-list-item">
          Click on the arrows in the top right corner and then confirm.
        </p>

        <img src="${connectNameService4Src.src}" alt="Showing where to click in metamask popup" width="2324" height="1308"/>

        <p class="html-list-item">
          When you confirm you are all set. And your domain is successfully registered.
        </p>

        <img src="${connectNameService5Src.src}" alt="Successful message" width="2324" height="906"/>
      </section>

      <p class="html-text-center">
        <a href="/hot-offers/zns-connect" class="html-button-primary">
          Mint your First Domain Now!
        </a>
      </p>
    </div>
  `,
  },
};
